import { ResolveBaseApiUrl } from "../utils/Utility";
import APIService from "./APIService";

const baseUrl = ResolveBaseApiUrl() + "Order/";
const orderAPIService = new APIService(baseUrl);

export async function GetOrderList(args) {
  var url = "getallorders";
  return await orderAPIService.postData(url, args);
}

// Customer Order API
export async function OrderDetailsByID(orderid, mode) {
  var url = `getorderbyid?orderid=${orderid}&mode=${mode}`;
  return await orderAPIService.fetchData(url);
}

export async function GetApplicantName({
  searchName,
  requestorid,
  investigatorid,
}) {
  var url = `getapplicantnames?searchText=${searchName}&requestorid=${requestorid}&investigatorid=${investigatorid}`;
  return await orderAPIService.fetchData(url);
}

export async function CreateOrder(order) {
  var url = "addorder";
  return await orderAPIService.putData(url, order);
}

export async function GetOrderDocumentById(docid) {
  const customHeaders = {
    Mode: "view",
  };
  var url = "getorderdocument?docid=" + docid;
  return await orderAPIService.fetchData(url, customHeaders);
}

export async function AssignOrderInvestigator(order) {
  var url = "assigninvestigator";
  return await orderAPIService.postData(url, order);
}

export async function UpdateOrderStatus(orderid, statusid, userid) {
  var url = `updateorderstatus?orderid=${orderid}&statusid=${statusid}&userid=${userid}`;
  return await orderAPIService.fetchData(url);
}

export async function DeleteOrderDoc(docid) {
  var url = `deleteorderdoc?docid=${docid}`;
  return await orderAPIService.deleteData(url);
}

export async function UpdateOrder(order) {
  var url = "updateorder";
  return await orderAPIService.patchData(url, order);
}
